import SearchIcon from "@mui/icons-material/Search";
import { Autocomplete, Box } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import { CampoDeTextoBase, OptionItem, TitleGroup } from "./styles";

const ExpandableSearch = ({ menusLiberados = [] }) => {
  const [searchValue, setSearchValue] = useState(null);
  const location = useLocation();
  const inputRef = useRef(null);

  // const handleExpand = () => setIsExpanded(true)

  // const handleCollapse = () => {
  //     setIsExpanded(false);
  //     setSearchValue(null);
  // };

  const options = useMemo(() => {
    const optionsFormatted = [];
    const menus = Array.isArray(menusLiberados)
      ? menusLiberados
      : Object.values(menusLiberados || {});

    const obterFilhos = (menu) =>
      Array.isArray(menu?.filhos) ? menu.filhos : Object.values(menu?.filhos || {});

    const encontrarAcao = (menu) => {
      if (typeof menu?.onClick === "function") {
        return menu.onClick;
      }

      return obterFilhos(menu).reduce((acao, filho) => acao || encontrarAcao(filho), null);
    };

    const recursiveHelper = (menu, path = "", rootGroup = "", palavrasChave = []) => {
      if (!menu || menu.ocultar || menu.oculto || !menu.nome) {
        return;
      }

      const currentPath = path || menu.nome;
      const group = rootGroup || menu.nome;
      const filhos = obterFilhos(menu);
      const palavrasChaveAtuais = [
        ...palavrasChave,
        ...(Array.isArray(menu.palavrasChave) ? menu.palavrasChave : []),
      ];
      const acao = encontrarAcao(menu);

      if (acao && (filhos.length === 0 || menu.indexarNaBusca)) {
        optionsFormatted.push({
          title: currentPath,
          group,
          link: acao,
          palavrasChave: palavrasChaveAtuais,
        });
      }

      filhos.forEach((filho) => {
        if (!filho?.nome) {
          return;
        }

        recursiveHelper(filho, `${currentPath} > ${filho.nome}`, group, palavrasChaveAtuais);
      });
    };

    menus.forEach((menu) => recursiveHelper(menu, "", menu?.nome || ""));

    return optionsFormatted;
  }, [menusLiberados]);

  const filtrarOpcoes = (opcoes, { inputValue }) => {
    const termo = (inputValue || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

    if (!termo) {
      return opcoes;
    }

    return opcoes.filter((option) => {
      const textoPesquisavel = [option.title, ...(option.palavrasChave || [])]
        .join(" ")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();

      return textoPesquisavel.includes(termo);
    });
  };

  const handleChange = (event, newValue) => {
    if (!newValue) {
      setSearchValue(null);
      return;
    }

    setSearchValue(null);
    newValue.link(event);
    inputRef.current?.blur();
  };

  useEffect(() => {
    setSearchValue(null);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        transition: "width 0.3s ease",
        width: "25%",
        maxWidth: "600px",
        overflow: "hidden",
        borderRadius: "16px",
      }}
    >
      <Autocomplete
        value={searchValue}
        onChange={handleChange}
        options={options}
        filterOptions={filtrarOpcoes}
        noOptionsText="Desculpe, nenhum resultado foi encontrado para a sua pesquisa."
        getOptionLabel={(option) => option?.title || ""}
        isOptionEqualToValue={(option, value) =>
          option.title === value.title && option.group === value.group
        }
        groupBy={(option) => option.group}
        renderGroup={(params) => (
          <div key={params.key}>
            <TitleGroup>{params.group}</TitleGroup>
            {params.children}
          </div>
        )}
        renderOption={(props, option) => (
          <li {...props}>
            <OptionItem>{option.title}</OptionItem>
          </li>
        )}
        sx={{ width: "100%" }}
        renderInput={(params) => (
          <CampoDeTextoBase
            {...params}
            placeholder="Buscar no sistema"
            InputProps={{
              ...params.InputProps,
              inputRef: inputRef,
              startAdornment: <SearchIcon />,
            }}
          />
        )}
      />
    </Box>
  );
};

export default ExpandableSearch;
